import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { Settings } from './settings.model';


@Injectable()
export class SettingsService {

    constructor(
        private http: HttpClient
    ) { }

    /**
     * Gets app settings
     */
    getSettings(): Observable<Settings> {
        return this.http.get<Settings>(`${environment.apiBaseURL}/tenant-settings`);
    }
}
